<div style="min-height: 260px; min-width: 640px">
  <div class="text-white w-full bg-orange-500 p-4">Add Property</div>
  <div class="flex mb-2 !w-[960px] flex-auto pl-4 pr-9 flex-col">
    <div class="mt-4">Based on where you dropped the pin, here what's we found:</div>
    <div class="mt-4">
      <ul>
        <li>Nearest Address: {{ address }}</li>
        <li>City: {{ city }}</li>
        <li>State: {{ state }}</li>
        <li>Latitude & Longitude: {{ latitude }}, {{ longitude }}</li>
      </ul>
    </div>
  </div>
  <div class="mt-4 bg-gray-200 !h-[1px] w-full mb-4"></div>
  <div class="flex flex-row gap-1 justify-end pr-4">
    <button (click)="onCancel()" mat-button class="border-gray-200 border border-solid">Cancel</button>
    <button (click)="saveOnlyLatLng()" mat-button class="bg-orange-500 text-white">Save only lat/long</button>
    <button mat-button (click)="saveCompleteAddress()" class="bg-orange-500 text-white">Save complete address</button>
  </div>
</div>
